import {Component} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {SharedService} from '../../../shared-components/shared.service';
import {Router} from '@angular/router';

@Component({
	selector: 'no-categories-warning-dialog',
	templateUrl: './no-categories-warning-dialog.component.html',
	styleUrls: [
		'./no-categories-warning-dialog.component.css'
	]
})
export class NoCategoriesWarningDialogComponent {

	// Properties

	// Class Functions
	constructor(
		private dialogBox: MatDialogRef<NoCategoriesWarningDialogComponent>,
		private sharedService: SharedService,
		private router: Router
	) { }

	// Event Functions
	close() {
		// POST: closes the dialog box and reroutes to the previous route
		this.dialogBox.close();
		this.router.navigateByUrl(this.sharedService.previousUrl);
	}

	// Methods
}